import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

export function Carregando({ texto = 'Carregando…' }: { texto?: string }) {
  return (
    <div className="flex min-h-[60vh] items-center justify-center gap-3 text-tinta-3" role="status">
      <Loader2 className="size-5 animate-spin" aria-hidden />
      <span className="text-sm">{texto}</span>
    </div>
  );
}

/**
 * Estado vazio informativo: diz o que falta e oferece o caminho.
 * Uma tela vazia que só diz "nenhum resultado" transfere para a pessoa o
 * trabalho de descobrir por quê.
 */
export function Vazio({
  titulo,
  descricao,
  acao,
  icone,
}: {
  titulo: string;
  descricao: string;
  acao?: ReactNode;
  icone?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-md border border-dashed border-regua-2 bg-superficie px-6 py-12 text-center">
      {icone && <div className="text-tinta-3">{icone}</div>}
      <h3 className="text-base font-semibold">{titulo}</h3>
      <p className="max-w-md text-sm text-tinta-2">{descricao}</p>
      {acao}
    </div>
  );
}

export function Erro({ titulo, detalhe }: { titulo: string; detalhe?: string }) {
  return (
    <div className="rounded-md border-l-3 border-pend bg-pend/10 px-4 py-3" role="alert">
      <p className="text-sm font-semibold text-pend">{titulo}</p>
      {detalhe && <p className="mt-1 text-sm text-tinta-2">{detalhe}</p>}
    </div>
  );
}
